import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./search.svg"; export default path + "#$"